// 쿠키설정 : 아이디 저장
function setCookie(cName, cValue, cDay) {
  let expire = new Date();
  expire.setDate(expire.getDate() + cDay);
  let cookies = cName + '=' + escape(cValue) + '; path=/ ';
  if (typeof cDay != 'undefined') cookies += ';expires=' + expire.toGMTString() + ';';
  document.cookie = cookies;
}

export {setCookie}